import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

export default function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const { state, actions } = useApp();

  const handleKeyDown = useCallback(
    (event) => {
      // Don't trigger shortcuts when typing in inputs
      if (
        event.target.tagName === 'INPUT' ||
        event.target.tagName === 'TEXTAREA' ||
        event.target.isContentEditable ||
        !state.keyboardShortcutsEnabled
      ) {
        return;
      }

      // Ignore if modifier keys are pressed (except for specific combos)
      if (event.ctrlKey || event.metaKey || event.altKey) {
        return;
      }

      switch (event.key.toLowerCase()) {
        case 'r':
          // Refresh data
          event.preventDefault();
          actions.triggerRefresh();
          break;

        case 'd':
          // Toggle dark/light mode
          event.preventDefault();
          actions.toggleTheme();
          break;

        case 's':
          // Toggle sidebar
          event.preventDefault();
          actions.toggleSidebar();
          break;

        case '1':
          // Navigate to Dashboard
          event.preventDefault();
          navigate('/');
          break;

        case '2':
          // Navigate to Generation
          event.preventDefault();
          navigate('/generation');
          break;

        case '3':
          // Navigate to Physical Notifications
          event.preventDefault();
          navigate('/physical-notifications');
          break;

        case '4':
          // Navigate to Bid Offer Acceptances
          event.preventDefault();
          navigate('/bid-offer-acceptances');
          break;

        case '5':
          // Navigate to Bid Offer Data
          event.preventDefault();
          navigate('/bid-offer-data');
          break;

        case '?':
          // Show keyboard shortcuts help (handled by Header component)
          break;

        case 'escape':
          // Reset filters
          event.preventDefault();
          actions.resetFilters();
          break;

        default:
          break;
      }
    },
    [navigate, actions, state.keyboardShortcutsEnabled]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
}
